// react
import React, {useState} from 'react';
import axios from 'axios';
import {Button, Form} from 'react-bootstrap';

// local
import './App.css';

/**
 * App URL definitions.
 */
export const WADOL_URL = 'https://sandbox.wadol.lecticon.com/';
export const WADOL_TOKEN = '975fcb573e35c58eec7a6aa6de1ac3f2';

const webservice = axios.create({
	baseURL: WADOL_URL,
	url: '/webservice/rest/server.php',
	method: 'POST',
	withCredentials: false,
});

function App() {
	const [lastName, setLastName] = useState('');
	const [dob, setDob] = useState('');
	const [license, setLicense] = useState('');
	const [dobError, setDobError] = useState('');
	const [licenseError, setLicenseError] = useState('');

	const dobPattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
	const licensePattern = /^WDL[A-Za-z0-9]{9}$/;

	const formComplete =
		lastName.trim() !== '' &&
		dobPattern.test(dob) &&
		licensePattern.test(license);

	const handlelicenseChange = (value: string) => {
		const upper = value.toUpperCase();
		const prefix = 'WDL'.slice(0, Math.min(upper.length, 3));
		const rest = upper.slice(3).replace(/[^A-Z0-9]/g, '').slice(0, 9);
		setLicense(upper.length <= 3 ? prefix : prefix + rest);
	};

	const handleDobChange = (value: string) => {
		const digits = value.replace(/\D/g, '').slice(0, 8);
		let formatted = digits;
		if (digits.length >= 5) {
			formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
		} else if (digits.length >= 3) {
			formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`;
		}
		setDob(formatted);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		// Validate inputs.
		let valid = true;
		if (!dobPattern.test(dob)) {
			setDobError('Date of birth must be in MM/DD/YYYY format.');
			valid = false;
		} else {
			setDobError('');
		}
		if (!licensePattern.test(license)) {
			setLicenseError('license must be WDL followed by 9 alphanumeric characters.');
			valid = false;
		} else {
			setLicenseError('');

		}
		if (!valid) {
			return;
		}

		// setup
		const options = new FormData();
		options.append('wstoken', WADOL_TOKEN);
		options.append('wsfunction', 'wadol_authenticate');
		options.append('moodlewsrestformat', 'json');
		options.append('lastname', lastName);
		options.append('birthdate', dob);
		options.append('license', license);

		// Make the request.
		try {
			const results = await webservice.post('/webservice/rest/server.php', options);
			if (results && results.status === 200) {
				if (results.data && results.data.success && results.data.url) {
					window.location.href = results.data.url;
				} else {
					alert('wadol_authenticate response:\n' + JSON.stringify(results.data, null, 2));
				}
			}
		} catch (err) {
			alert('wadol_authenticate failed:\n' + (err instanceof Error ? err.message : String(err)));
		}
	};

	return (
		<div className="login-page">
			<div className="login-topbar"/>
			<div className="login-card">
				<div className="login-logo">
					<img
						src="https://sandbox.wadol.lecticon.com/pluginfile.php/1/core_admin/logo/0x200/1775755163/DOL2024_Color-Logotype.jpg"
						alt="Washington State Department of Licensing"
					/>
				</div>

				<Form onSubmit={handleSubmit} className="login-form">
					<Form.Group className="mb-3" controlId="login-lastname">
						<Form.Control
							type="text"
							placeholder="Last Name"
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
						/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="login-dob">
						<Form.Control
							type="text"
							placeholder="Date of Birth (MM/DD/YYYY)"
							value={dob}
							onChange={(e) => handleDobChange(e.target.value)}
							isInvalid={!!dobError}
						/>
						<Form.Control.Feedback type="invalid">
							{dobError}
						</Form.Control.Feedback>
					</Form.Group>

					<Form.Group className="mb-3" controlId="login-license">
						<Form.Control
							type="text"
							placeholder="Drivers license # (WDLXXXXXXXXX)"
							value={license}
							onChange={(e) => handlelicenseChange(e.target.value)}
							isInvalid={!!licenseError}
						/>
						<Form.Control.Feedback type="invalid">
							{licenseError}
						</Form.Control.Feedback>
					</Form.Group>

					<Button
						type="submit"
						variant={formComplete ? 'primary' : 'secondary'}
						className="login-submit"
						disabled={!formComplete}
					>
						Log in
					</Button>
				</Form>

			</div>
		</div>
	);
}

export default App;
